// hooks/useCotaUsuario.ts
import { useState, useEffect } from "react";
import { Empreendimento } from "../../../interfaces/Empreendimento";
import { buscarEmpreendimentosService } from "../../../services/buscarEmpreendimentosService";

export const useEmpreendimentosSystem = (validarEmpreendimento: boolean) => {
  const [isLoading, setIsLoading] = useState(true);
  const [empreendimentos, setEmpreendimentos] = useState<Empreendimento[]>([]);

  useEffect(() => {
    const fetchBuscarEmpreendimentosSystem = async () => {
      if (validarEmpreendimento) {
        setIsLoading(true);

        try {
          const data = await buscarEmpreendimentosService();
          if (data) {
            setEmpreendimentos(data);
          } else {
            console.error("Dados não encontrados");
          }
        } catch (error) {
          console.error("Erro ao buscar empreendimentos:", error);
        } finally {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    };

    fetchBuscarEmpreendimentosSystem();
  }, [validarEmpreendimento]); // Dependência
  return { isLoading, empreendimentos };
};
